<template>
  <div class="range-slider-background">
    <loading v-if="loading" />
    <error-messages
      v-else-if="!loading && showError"
      :show="showError"
      :messages="errorMessages"
    />
    <div v-else>
      <!-- RAM -->
      <slider-renge-resource-item
        icon="border-style"
        planTitleFa="حافظه"
        planTitleEn="RAM"
        :unit="ram.unit"
        :value="ram.value"
        :min="ram.minValue"
        :max="ram.maxValue"
        :interval="ram.growthRate"
        @update="updateRam"
      />
      <!-- CPU -->
      <slider-renge-resource-item
        icon="cpu"
        planTitleFa="پردازنده"
        planTitleEn="CPU"
        :value="cpu.value"
        :unit="cpu.unit"
        :min="cpu.minValue"
        :max="cpu.maxValue"
        :interval="cpu.growthRate"
        @update="updateCpu"
      />
      <!-- Storage -->
      <slider-renge-resource-item
        icon="hdd"
        planTitleFa="فضا"
        planTitleEn="STORAGE"
        :value="storage.value"
        :unit="storage.unit"
        :min="storage.minValue"
        :max="storage.maxValue"
        :interval="storage.growthRate"
        @update="updateStorage"
        :disabled="storageDisabled"
      />
      <b-row>
        <b-col cols="12" class="price-description">
          هزینه سرویس ابری:
          <span>{{ totalPrice }}</span>
          ریال / ساعتی
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import "vue-slider-component/theme/material.css";
import ErrorMessages from "@/components/ErrorMessages/ErrorMessages.vue";
import Loading from "@/components/Loading/Loading.vue";
import SliderRengeResourceItem from "../SliderRengeResourceItem/SliderRengeResourceItem.vue";
import {
  SET_RESOURCE,
  SET_RAM,
  SET_CPU,
  SET_STORAGE,
  TOTAL_PRICE,
  SET_RESOURCE_SERVICE,
  SET_DEFAULT_RESOURCE
} from "@/store/mutation-types";

export default {
  props: {
    createNew: {
      type: Boolean,
      default: true
    },
    storageDisabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    SliderRengeResourceItem,
    ErrorMessages,
    Loading
  },
  computed: {
    ...mapState("resource", [
      "ram",
      "cpu",
      "storage",
      "errorMessages",
      "showError",
      "loading"
    ]),
    ...mapGetters("resource", [TOTAL_PRICE])
  },
  mounted() {
    this[SET_RESOURCE]();
    this.$route.params.serviceId
      ? this[SET_RESOURCE_SERVICE](this.$route.params.serviceId)
      : this[SET_DEFAULT_RESOURCE]();
  },
  methods: {
    ...mapActions("resource", [
      SET_RESOURCE,
      SET_RAM,
      SET_CPU,
      SET_STORAGE,
      SET_RESOURCE_SERVICE,
      SET_DEFAULT_RESOURCE
    ]),
    updateRam: function(val) {
      this[SET_RAM](val);
    },
    updateCpu: function(val) {
      this[SET_CPU](val);
    },
    updateStorage: function(val) {
      this[SET_STORAGE](val);
    }
  }
};
</script>
<style lang="scss">
.range-slider-background {
  color: #3e89d1;
  padding: 15px 0;
  border-radius: 6px;
  display: flex;
  flex-direction: column;

  .price-description {
    color: #288ed9;
    text-align: center;

    & span {
      font-weight: bold;
    }

    @media screen and (min-width: 768px) {
      & {
        font-size: 18px;

        & span {
          font-size: 20px;
        }
      }
    }
    @media screen and (max-width: 768px) {
      & {
        font-size: 16px;
        & span {
          font-size: 18px;
        }
      }
    }
    @media screen and (max-width: 576px) {
      & {
        font-size: 14px;
        & span {
          font-size: 15px;
        }
      }
    }
  }
}
</style>
